module.exports = __webpack_public_path__ + "img/about/80243-034.png";


//////////////////
// WEBPACK FOOTER
// ./img/about/80243-034.png
// module id = 34
// module chunks = 0